// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__8y61P","primaryBtn":"Button_primaryBtn__-d04z","secondaryBtn":"Button_secondaryBtn__-momj"};